import React, {useState, useEffect, useCallback} from "react";
import ProfileImageSection from "../components/profile-image-section";
import ThemeSection from "../components/theme-section";
import VisibilitySection from "../components/visibility-section";
import {DEFAULT_THEME_COLORS} from "../../core/constants/theme";
import {useAppMetadata} from "../../core/hooks/use-app-metadata";
import VisitRequirementSection from "../components/visit-requirement-section";
import VisitRequirementPreviewModel from "../components/visit-requirement-preview-model";
import useModalWithData from "@common/hooks/use-modal-with-data";
import {ModalIds} from "@common/models/enums/modal-ids.enum";
import DeactivateWidgetModal, {DeactivateWidgetModalData} from "../components/deactivate-widget-modal";
import ImageCropperModal from "../../core/components/image-cropper-modal";

const SettingsView: React.FC = () => {
    const {appMetadata, updateTheming, toggleVisibility} = useAppMetadata();
    const [selectedThemeId, setSelectedThemeId] = useState<string>("PRIMARY");
    const isAppVisible = appMetadata?.hidden === false;
    const {showModal: showDeactivateModal} = useModalWithData<DeactivateWidgetModalData>(ModalIds.WIDGET_DEACTIVATE_CONFIRM);

    const handleThemeSelect = useCallback(async (themeId: string) => {
        setSelectedThemeId(themeId);
        try {
            await updateTheming(themeId);
        } catch (error) {
            if (appMetadata?.theming) {
                setSelectedThemeId(appMetadata.theming);
            }
        }
    }, [updateTheming, appMetadata]);

    const handleToggleVisibility = async () => {
        if (isAppVisible) {
            showDeactivateModal({ onConfirm: toggleVisibility });
        } else {
            await toggleVisibility();
        }
    };

    useEffect(() => {
        if (appMetadata?.theming) {
            setSelectedThemeId(appMetadata.theming);
        }
    }, [appMetadata]);

    return (
        <div className="flex flex-col gap-10">
            <header className="flex flex-col">
                <h1 className="text-[24px] leading-7 font-semibold text-on-surface">
                    Ustawienia
                </h1>
            </header>

            <section className="bg-white rounded-[24px] flex flex-col gap-12">
                <ProfileImageSection/>

                <ThemeSection
                    colors={DEFAULT_THEME_COLORS}
                    selectedId={selectedThemeId}
                    onSelect={handleThemeSelect}
                />

                <VisitRequirementSection/>

                <VisibilitySection
                    isVisible={isAppVisible}
                    onToggle={handleToggleVisibility}
                />
            </section>

            <VisitRequirementPreviewModel/>
            <DeactivateWidgetModal/>
            <ImageCropperModal/>
        </div>
    );
};

export default SettingsView;


